import { useMutation, useQuery } from '@tanstack/react-query'

import { getMissingFields, submitMissingFields } from './function'

export function useMissingFields(partnerId: string, customerId: number) {
  return useQuery(['useMissingFields', partnerId, customerId], () =>
    getMissingFields(partnerId, customerId)
  )
}

export function useSubmitMissingFields() {
  return useMutation(submitMissingFields)
}
